export type SubscriptionPromoModalOptionsUser = {
  avatarId: string;
};

export type SubscriptionPromoModalOptions = {
  userReceiver?: SubscriptionPromoModalOptionsUser;
};

export type SubscriptionPromoModalData = {
  userReceiver?: SubscriptionPromoModalOptionsUser;
};

export const enum SubscriptionFeature {
  ADVANCED_INFORMATION = 'advancedInformation',
  UNLOCK_LOCATION = 'unlockLocation',
  UNLIMITED_LIKES = 'unlimitedLikes',
  ADVANCED_SEARCH = 'advancedSearch',
  UNBLOCK_USERS = 'unblockUsers',
  UNLIMITED_MESSAGES = 'unlimitedMessages',
  DELETE_OWN_MESSAGES = 'deleteOwnMessages',
  ACTIVITY = 'activity',
  ADS = 'ads',
}
